import * as getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = 
{
  checkoutId: '',
  checkout: {},
  bottles: [],
  isLoading: false,
  masterclasses: [],
  checkoutSize: 0,
  lastTypeProduct: null
}

export default 
{
  state,
  getters,
  actions,
  mutations
}
